import { render } from "./AverageExchangeRate.vue?vue&type=template&id=fe66b9e2&scoped=true"
import script from "./AverageExchangeRate.vue?vue&type=script&lang=js"
export * from "./AverageExchangeRate.vue?vue&type=script&lang=js"

import "./AverageExchangeRate.vue?vue&type=style&index=0&id=fe66b9e2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe66b9e2"]])

export default __exports__